import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSGraphDashboardByHour } from "../api/RCSDashboardApi";

export const useGraphByHourRCS = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["RCSDashboardSummary"],
    queryFn: async () => {
      return await getRCSGraphDashboardByHour({ token: user.token });
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });
};
